import React from "react";
import { Link } from "gatsby";
import { Case_Arrow } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Caseusa = () => {
  return (
    <section className="case_flex">
      <div className="flex_item" style={{ backgroundColor: "#dc3c2a" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/react-native/case-logo-1.webp"
              alt="tekrevol_react"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={266}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>An Online Marketplace For Booking Registered Barbers</h3>
            <Link
              to="/case-studies/mocuts"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/react-native/case-study-1.webp"
            alt="tekrevol_react"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={675}
            height={460}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#000000" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/react-native/case-logo-2.webp"
              alt="tekrevol_react"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={216}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Empowering Your Wellness Journey</h3>
            <Link
              to="/case-studies/pure-plank"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/react-native/case-study-2.webp"
            alt="tekrevol_react"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#65ccc0" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/react-native/case-logo-3.webp"
              alt="tekrevol_react"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={220}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Stop Vaping Challenge App</h3>
            <Link
              to="/case-studies/stop-vaping"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/react-native/case-study-3.webp"
            alt="tekrevol_react"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
    </section>
  );
};

export default Caseusa;
